<template>
  <div class="wrapper_dark" @click="interactCheck" @touchstart="interactCheck">
    <div class="header">
      <button class="btn_back" @click="back">
        <img src="@/assets/img/left-arrow.svg" />
      </button>
      <h1 class="title">{{ $tc("personal_info") }}</h1>
      <button class="btn_exit" @click="goHome">{{ $tc("cancle") }}</button>
    </div>
    <div class="inner_wrap">
      <div class="privacy_input_wrap">
        <div class="input_items">
          <input
            class="privacy_name"
            type="text"
            :placeholder="namePlaceholder"
            :value="userName"
            maxlength="11"
            @input="nameChange"
          />
          <!-- 번호없음 옵션 사용 -->
          <div class="no_phone_warp" v-if="isUsePhoneNumber">
            <input
              class="privacy_num short"
              :class="{ 'disabled': isNoPhone }"
              type="tel"
              :disabled="isNoPhone"
              :placeholder="short_phone_placeholder"
              v-model="userPhoneNumber"
              maxlength="11"
            />
            <div class="no_phone" :class="{ 'active': isNoPhone, 'en': locale === 'en' }" @click="toogleIsNoPhone">
              <div class="check_box">
                <span></span>
              </div>
              <span>{{ $tc('no_phone') }}</span>
            </div>
          </div>
          <!-- 번호없음 옵션 사용 안함 -->
          <input v-else
            class="privacy_num"
            type="tel"
            :placeholder="$tc('enter_phone')"
            v-model="userPhoneNumber"
            maxlength="11"
          />
        </div>
        <div class="next_btn_wrap">
          <button
            class="next_btn"
            :class="{ active: isActive }"
            @click="validation"
          >{{ $tc("next") }}</button>
        </div>
      </div>
      <div class="privacy_notice">
        <h3 class="privacy_notice_title">{{ $tc("keep") }}</h3>
        <ul class="notice_content">
          <li>{{ $tc("number_correct") }}</li>
          <li v-html="$tc('noti_check')"></li>
          <li v-html="$tc('noshow')"></li>
        </ul>
      </div>
    </div>
    <Popup v-show="showPopup" @popControl="popup" />
    <AlertPopup v-show="showAlertPopup" :msg="msg" @AlertEvent="alertAction" />
    <SlotPopup v-show="showSlotPopup">
      <div class="icon" slot="icon">
        <img src="@/assets/img/camera.svg"/>
      </div>
      <div class="content" slot="content" v-html="$tc('noPhonePopupText')"></div>
      <div class="button_wrap" slot="button_wrap">
        <div class="button" @click="() => { this.showSlotPopup = false }">{{ $tc('confirmed') }}</div>
      </div>
    </SlotPopup>
    <timeout-popup :isShow="isShowTimeOutPop" @moveToHome="moveToHome" @close="closeTimeoutPopup"/>
  </div>
</template>

<script>
import { timeout } from './mixins/timeout'
import { viewport } from './mixins/viewport'
import timeoutPopup from '@/components/TimeOutPopup.vue'
import { mapState, mapGetters } from 'vuex'
import { getCustomNameLabel } from '../utills'
import Popup from '@/components/Popup.vue'
import AlertPopup from '@/components/AlertPopup'
import SlotPopup from '@/components/SlotPopup'

export default {
  name: 'PrivacyView',
  mixins: [timeout, viewport],
  components: {
    timeoutPopup,
    Popup,
    AlertPopup,
    SlotPopup
  },
  data () {
    return {
      userName: '',
      userPhoneNumber: '',
      short_phone_placeholder: this.$tc('enter_phone_short'),
      isActive: false,
      showPopup: false,
      msg: '',
      showAlertPopup: false,
      isNoPhone: false,
      showSlotPopup: false
    }
  },
  computed: {
    ...mapState(['locale']),
    ...mapGetters({ restaurant: 'getRestaurantInfo', waitingParams: 'getWaitingParams', storeIdx: 'getStoreIdx' }),
    isUsePhoneNumber () {
      return this.restaurant.isPhoneNumber
    },
    // 특정 매장은 이름 입력란 placeholder를 커스텀 텍스트로 표기 (TB-14754, 병원 매장 "이름 / 생년월일")
    namePlaceholder () {
      return getCustomNameLabel(this.storeIdx) || this.$tc('input_name')
    }
  },
  watch: {
    userPhoneNumber (val) {
      this.checkActive()
    },
    isNoPhone () {
      this.checkActive()
    }
  },
  methods: {
    nameChange (event) {
      this.userName = event.target.value.trim()
      this.checkActive()
    },
    checkActive () {
      this.interactCheck()
      this.userPhoneNumber = this.userPhoneNumber ? this.userPhoneNumber.trim() : ''
      if (this.userName.length >= 2 && ((!this.isNoPhone && this.userPhoneNumber.length >= 11) || this.isNoPhone)) {
        this.isActive = true
      } else {
        this.isActive = false
      }
    },
    validation () {
      if (!this.isActive) { return }
      let firstNum = /^[0]/ // 핸드폰 번호는 0으로 시작
      let patternNum = /^[0-9]*$/ // 숫자
      let patternSpc = /[~!@#$%^&*()_+|<>?:{}]/ // 특수문자

      // 특수문자 체크
      if (patternSpc.test(this.userName)) {
        this.isActive = false
        this.showAlertPopup = true
        this.msg = this.$tc('special')
        return
      }

      // 숫자만 입력 체크
      if (this.isNoPhone) {
        this.next()
      } else {
        if ((firstNum.test(this.userPhoneNumber)) && (patternNum.test(this.userPhoneNumber))) {
          this.next()
        } else {
          this.isActive = false
          this.showAlertPopup = true
          this.msg = this.$tc('phone_check')
        }
      }
    },
    toogleIsNoPhone () { // 전화번호기능 없음 처리함수
      this.isNoPhone = !this.isNoPhone
      if (this.isNoPhone) {
        this.userPhoneNumber = ''
        this.short_phone_placeholder = this.$tc('no_phone_text')
        this.showSlotPopup = true
      } else {
        this.short_phone_placeholder = this.$tc('enter_phone_short')
      }
    },
    next () {
      const params = {
        name: this.userName,
        phoneNumber: this.userPhoneNumber,
        isNoPhone: this.isNoPhone
      }
      if (this.isNoPhone) {
        params.menus = new Map()
      }
      this.$store.commit('setWaitingParams', params)
      this.$router.push('/select-person')
    },
    goHome () {
      this.showPopup = true
    },
    popup (type) {
      if (type === 'cancle') {
        this.$router.push('/')
      } else {
        this.showPopup = false
      }
    },
    back () {
      const path = (this.locale !== 'ko' && this.restaurant.foreignRequestType && this.restaurant.foreignRequestType.length > 0) ? '/bifurcation' : '/notice'
      this.$router.push(path)
    },
    alertAction (type) {
      if (type === 'close') {
        this.showAlertPopup = false
      }
    }
  },
  mounted () {
    if (this.waitingParams.name !== '') {
      this.userName = this.waitingParams.name
    }
    if (this.waitingParams.phoneNumber !== '') {
      this.userPhoneNumber = this.waitingParams.phoneNumber
    }
    if (this.waitingParams.isNoPhone) {
      this.isNoPhone = this.waitingParams.isNoPhone
      this.short_phone_placeholder = this.$tc('no_phone_text')
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/base.scss";

.inner_wrap {
  display: flex;
  flex-direction: column;
  @include flex-gap(vh(5), column);
  padding: vh(8.75) vh(17.5);
}
.privacy_input_wrap {
  display: flex;
  @include flex-gap(vh(3), row);
  .input_items {
    display: flex;
    flex-direction: column;
    @include flex-gap(vh(3), column);
    width: 100%;
    input {
      border-radius: vh(2);
      border: 2px solid #B7BEC8;
      background: #FFF;
      padding: vh(2.75);
      font-size: 28px; // IE11 fallback
      font-size: unquote("min(#{vh(3.5)}, 28px)");
      font-weight: 600;
      color: #2E3137;
      line-height: vh(4.5);
      &::placeholder {
        color: #969FAC;
      }
      &:focus {
        outline: 2px solid #2E3137;
        outline-offset: -2px;
      }
    }
    .no_phone_warp {
      display: flex;
      align-items: center;
      @include flex-gap(vh(3), row);
      input {
        width: 100%;
        &.disabled {
          // border: none;
          // background: transparent;
          background: #ECEEF0;
          &::placeholder {
            color: #969FAC;
          }
        }
      }
      .no_phone {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        @include flex-gap(vh(1.5), row);
        width: vh(31);
        padding: vh(2.75) vh(2.2);
        border-radius: vh(2);
        background: #ffffff;
        font-size: 28px; // IE11 fallback
        font-size: unquote("min(#{vh(3.5)}, 28px)");
        font-weight: 600;
        color: #969FAC;
        line-height: vh(4.5);
        border: 2px solid #B7BEC8;
        cursor: pointer;
        &.en {
          width: vh(26);
        }
        .check_box {
          display: flex;
          justify-content: center;
          align-items: center;
          width: vh(4);
          height: vh(4);
          padding: vh(0.5);
          border-radius: vh(1);
          background: #B7BEC8;
          &::after {
            content: '';
            display: block;
            width: vh(2.125);
            height: vh(1.5);
            background: url('~@/assets/img/white/check.svg') no-repeat center center;
          }
        }
        &.active {
          color: #2E3137;
          .check_box {
            background: #2E3137;
          }
        }
      }
    }
  }
  .next_btn_wrap {
    button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: vh(31.25);
      height: vh(24);
      border-radius: vh(2.5);
      background: #B7BEC8;
      color: #FFF;
      font-size: 32px; // IE11 fallback
      font-size: unquote("min(#{vh(4)}, 32px)");
      font-weight: 700;
      &.active {
        background: #D81B1B;
      }
    }
  }
}
.privacy_notice {
  display: flex;
  padding: vh(3) vh(3.5);
  flex-direction: column;
  @include flex-gap(vh(1), column);
  border-radius: vh(2.5);
  background: #ECEEF0;
  .privacy_notice_title {
    color: #D81B1B;
    font-size: 26px; // IE11 fallback
    font-size: unquote("min(#{vh(3.25)}, 26px)");
    font-weight: 700;
    line-height: vh(4.75);
  }
  .notice_content {
    color: #2E3137;
    font-size: 24px; // IE11 fallback
    font-size: unquote("min(#{vh(3)}, 24px)");
    font-weight: 400;
    line-height: vh(5);
    li {
      margin-left: vh(3.5);
      list-style: disc;
    }
  }
}
</style>
